<template>
  <div>
    <Pane title="员工瓴云账号信息填写表" :showRemarks="false">
      <template>重新发起员工瓴云账号信息填写表流程</template>
    </Pane>
    <div style="padding: 0 10px">
      <BranchEmployeeForm
        ref="form"
        :editData="extra"
        @submit="handleSubmit"
        @close="handleClose"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import BranchEmployeeForm from "@/views/human-resources/hr/branch/employee/form.vue";
import { resubmit } from "@/api/human-resources/branchEmployee";

export default {
  components: {
    BranchEmployeeForm,
  },
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return this.detail && this.detail.extra ? this.detail.extra : {};
    },
  },
  mounted() {
    // 直接打开/刷新页面时审批详情 store 可能为空，兜底加载
    if (!this.detail || Object.keys(this.detail).length === 0) {
      this.loadDetail();
    }
  },
  methods: {
    ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
    ...mapActions("approval", ["getDetail"]),
    loadDetail() {
      const { taskId, instanceId } = this.$route.query;
      if (!taskId || !instanceId) return;
      this.setTaskId(taskId);
      this.setInstanceId(instanceId);
      this.getDetail();
    },
    handleSubmit(payload) {
      this.$refs.form.setLoading(true);
      resubmit(payload)
        .then(() => {
          this.$message.success("提交成功");
          this.handleClose();
        })
        .finally(() => {
          this.$refs.form.setLoading(false);
        });
    },
    handleClose() {
      this.$close(this.$route.path);
    },
  },
};
</script>
